import { createHash } from 'crypto';

export default class Sha256 {
  static make(data: any): string {
    return createHash('sha256')
      .update(data || new Date().getTime())
      .digest('base64');
  }
}
